export interface Emit {
  (e: 'click'): void;
}
export interface Props {
  btnDisabled?: boolean;
  message?: string;
  buttonTitle?: string;
}

export const setup = (emit: Emit) => {
  const onClick = () => {
    emit('click');
  };
  return {
    onClick,
  };
};
